/** @jsxImportSource @emotion/react */
import React, { useMemo, useState } from "react";
import { css } from "@emotion/react";
import { HighlightedText } from "..";

const ReadMoreText = ({
  text = "",
  searchText = "",
  maxChars = 300,
  partialSearch = false,
}) => {
  const [expanded, setExpanded] = useState(false);
  const isOverflowing = text?.length > maxChars;

  const toggleReadMore = () => setExpanded((prev) => !prev);

  const containerStyle = css`
    white-space: pre-line;
    word-break: break-word;
    cursor: default;
  `;

  const displayText = expanded ? text : text?.slice(0, maxChars);

  return (
    <div>
      <div css={containerStyle}>
        <>
          <HighlightedText
            text={displayText}
            searchText={searchText}
            partialSearch={partialSearch}
          />
          {isOverflowing && <span>...</span>}
        </>
      </div>

      {isOverflowing && (
        <span
          onClick={toggleReadMore}
          style={{
            color: "#1890ff",
            cursor: "pointer",
            display: "inline-block",
            marginTop: 4,
          }}
        >
          {expanded ? "Show less" : "Read more"}
        </span>
      )}
    </div>
  );
};

export default ReadMoreText;
